/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AfterOrderBannerCreatedBy } from './after-order-banner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { AfterOrderBannerImage } from './after-order-banner-image';
// May contain unused imports in some cases
// @ts-ignore
import { LandingContentsCityCardsInner } from './landing-contents-city-cards-inner';
// May contain unused imports in some cases
// @ts-ignore
import { LandingContentsDistancesInner } from './landing-contents-distances-inner';
// May contain unused imports in some cases
// @ts-ignore
import { LandingContentsFaqsInner } from './landing-contents-faqs-inner';
// May contain unused imports in some cases
// @ts-ignore
import { LandingContentsLinkBoxInner } from './landing-contents-link-box-inner';
// May contain unused imports in some cases
// @ts-ignore
import { LandingContentsProvidersInner } from './landing-contents-providers-inner';
// May contain unused imports in some cases
// @ts-ignore
import { LandingContentsQuickAccessItemsInner } from './landing-contents-quick-access-items-inner';
// May contain unused imports in some cases
// @ts-ignore
import { LandingContentsSectionInner } from './landing-contents-section-inner';
// May contain unused imports in some cases
// @ts-ignore
import { LandingContentsTripCardCitiesInner } from './landing-contents-trip-card-cities-inner';

/**
 * 
 * @export
 * @interface LandingContents
 */
export interface LandingContents {
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'parent'?: LandingContentsParentEnum;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'cityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'locale'?: LandingContentsLocaleEnum;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'customPageTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'customPageDescription'?: string;
    /**
     * 
     * @type {Array<LandingContentsLinkBoxInner>}
     * @memberof LandingContents
     */
    'linkBox'?: Array<LandingContentsLinkBoxInner>;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'defaultTab'?: LandingContentsDefaultTabEnum;
    /**
     * 
     * @type {Array<LandingContentsFaqsInner>}
     * @memberof LandingContents
     */
    'faqs'?: Array<LandingContentsFaqsInner>;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'mode'?: LandingContentsModeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof LandingContents
     */
    'corpIds'?: Array<string>;
    /**
     * 
     * @type {Array<LandingContentsDistancesInner>}
     * @memberof LandingContents
     */
    'distances'?: Array<LandingContentsDistancesInner>;
    /**
     * 
     * @type {AfterOrderBannerImage}
     * @memberof LandingContents
     */
    'image'?: AfterOrderBannerImage;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'h1Title'?: string;
    /**
     * 
     * @type {AfterOrderBannerImage}
     * @memberof LandingContents
     */
    'ogImage'?: AfterOrderBannerImage;
    /**
     * 
     * @type {Array<LandingContentsSectionInner>}
     * @memberof LandingContents
     */
    'Section'?: Array<LandingContentsSectionInner>;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'redirectUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof LandingContents
     */
    'redirectErrorCode'?: number;
    /**
     * 
     * @type {Array<LandingContentsProvidersInner>}
     * @memberof LandingContents
     */
    'Providers'?: Array<LandingContentsProvidersInner>;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'ProvidersTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'CityCardTitle'?: string;
    /**
     * 
     * @type {Array<LandingContentsCityCardsInner>}
     * @memberof LandingContents
     */
    'CityCards'?: Array<LandingContentsCityCardsInner>;
    /**
     * 
     * @type {Array<LandingContentsQuickAccessItemsInner>}
     * @memberof LandingContents
     */
    'QuickAccessItems'?: Array<LandingContentsQuickAccessItemsInner>;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'QuickAccessLayout'?: LandingContentsQuickAccessLayoutEnum;
    /**
     * 
     * @type {Array<LandingContentsTripCardCitiesInner>}
     * @memberof LandingContents
     */
    'TripCardCities'?: Array<LandingContentsTripCardCitiesInner>;
    /**
     * 
     * @type {number}
     * @memberof LandingContents
     */
    'TripCardMaxDays'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LandingContents
     */
    'HideAdvantages'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LandingContents
     */
    'provinceName'?: string;
    /**
     * 
     * @type {AfterOrderBannerCreatedBy}
     * @memberof LandingContents
     */
    'created_by'?: AfterOrderBannerCreatedBy;
    /**
     * 
     * @type {AfterOrderBannerCreatedBy}
     * @memberof LandingContents
     */
    'updated_by'?: AfterOrderBannerCreatedBy;
}

export const LandingContentsParentEnum = {
    Flights: 'flights',
    Trains: 'trains',
    Buses: 'buses',
    ShipTicket: 'ship_ticket',
    Taxi: 'taxi',
    CarRental: 'car_rental',
    TrainTicket: 'train_ticket',
    Hotel: 'hotel',
    Underscore: '_'
} as const;

export type LandingContentsParentEnum = typeof LandingContentsParentEnum[keyof typeof LandingContentsParentEnum];
export const LandingContentsLocaleEnum = {
    Fa: 'fa',
    En: 'en',
    Ar: 'ar'
} as const;

export type LandingContentsLocaleEnum = typeof LandingContentsLocaleEnum[keyof typeof LandingContentsLocaleEnum];
export const LandingContentsDefaultTabEnum = {
    Flight: 'flight',
    Train: 'train',
    Bus: 'bus',
    Taxi: 'taxi',
    Hotel: 'hotel',
    Ship: 'ship',
    Bundle: 'bundle'
} as const;

export type LandingContentsDefaultTabEnum = typeof LandingContentsDefaultTabEnum[keyof typeof LandingContentsDefaultTabEnum];
export const LandingContentsModeEnum = {
    Domestic: 'domestic',
    Foreign: 'foreign'
} as const;

export type LandingContentsModeEnum = typeof LandingContentsModeEnum[keyof typeof LandingContentsModeEnum];
export const LandingContentsQuickAccessLayoutEnum = {
    Column: 'Column',
    SingleRow: 'SingleRow',
    DoubleRow: 'DoubleRow'
} as const;

export type LandingContentsQuickAccessLayoutEnum = typeof LandingContentsQuickAccessLayoutEnum[keyof typeof LandingContentsQuickAccessLayoutEnum];


